import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators'
import store from '@/store'
import api from '@/api'
import Cookies from 'js-cookie'
import { IUserState, ILoginInfo, IUserInfo, IPower,IOrgParam } from '@/model/userState'

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public staticKey: string = localStorage.getItem('STATIC_KEY') || ''
  public name: string = localStorage.getItem('USER_NAME') || ''
  public token: string = Cookies.get('TOKEN') || ''
  public pubkey: string = Cookies.get('PUB_KEY') || ''
  public isLogin: boolean = false
  public loginInfo: ILoginInfo = {} as ILoginInfo
  public orgParam:IOrgParam={} as IOrgParam

  public get userInfo(): IUserInfo {
    const user = this.loginInfo.user || {}
    const roleObj = this.powerList.find(i => i.id === user.role) || {} as IPower
    return { ...user, roleName: roleObj.name || '' }
  }
  /** 网络列表 */
  public networkList: any[] = []
  /** 用户角色列表 */
  public get powerList() {
    return this.loginInfo.power || []
  }
  /** 用户说明文档 */
  public get userDoc() {
    return this.loginInfo.USER_DOC || ''
  }
  /** 公司信息 */
  public get orgInfo() {
    return this.loginInfo.org || {}
  }
  //项目参数信息
  public get orgParams() {

   return this.orgParam||{}
  }

  /** 空间类型 */
  public get spaceTypeList() {
    return this.loginInfo.spaceType || []
  }
  /** 管理区域列表 */
  public orgPosList: any[] = []
  /** 部门列表 */
  public orgDeptList: any[] = []
  /** 管理区域列表 */
  public orgPosListByElectric: any[] = []
  @Mutation
  public setStaticKey(key: string) {
    localStorage.setItem('STATIC_KEY', key)
    this.staticKey = key
  }

  @Mutation
  public setPubKey(key: string) {
    Cookies.set('PUB_KEY', key)
    this.pubkey = key
  }

  @Action({ commit: 'SetUserInfo' })
  public async Login(params: { name: string, pwd: string, key: string }) {
    const loginInfo: any = await api.login(params)
    return loginInfo
  }
  @Action({ commit: 'SetUserInfo' })
  public async codeLogin(params: { code: string }) {
    const loginInfo: any = await api.codeLogin(params)
    return loginInfo
  }

  @Action({ commit: 'SetUserInfo' })
  public async GetUserInfo() {
    const loginInfo: any = await api.getLoginInfo({ name: UserModule.name })
    // console.log(loginInfo);
    return loginInfo
  }
  @Action({ commit: 'SetOrgParam' })
  public async getOrgParam() {
    const OrgParam: any = await api.getOrgParam(UserModule.orgInfo.orgId)
  //  console.log(OrgParam)
    return OrgParam
  }
  @Action({ commit: 'SetOrgParam' })
  public async updOrgParam(data:any) {
    const OrgParam: any = await api.updOrgParam(data)
  //  console.log(OrgParam)
    return OrgParam
  }
  @Mutation
  private async SetOrgParam(OrgParam: any) {
    // console.log(OrgParam);
   this.orgParam = OrgParam
  //  
    




  }

  @Mutation
  private async SetUserInfo(loginInfo: any) {
    localStorage.setItem('USER_NAME', loginInfo.user.name)
    // console.log(loginInfo);

    this.name = loginInfo.user.name
    Cookies.set('TOKEN', loginInfo.token)
    this.token = loginInfo.token
    this.loginInfo = loginInfo
    this.isLogin = true
    await UserModule.getOrgPosTree()
    await UserModule.getOrgPosTreeByElectric()
  }

  @MutationAction({ mutate: ['isLogin'] })
  public async LoginOut() {
    Cookies.remove('TOKEN')
    Cookies.remove('PUB_KEY')
    localStorage.removeItem('USER_NAME')
    localStorage.removeItem('STATIC_KEY')
    return {
      isLogin: false,
    }
  }
  @Action
  public async getOrgPosTree() {
    // console.log(JSON.stringify(UserModule.orgPosList))
    
    if (UserModule.orgPosList.length > 0) {
      return UserModule.orgPosList
    }
    // console.log(UserModule);
    const data = await api.getOrgPosTree({ orgId: UserModule.orgInfo.orgId })
    // console.log(data);
    
    const { orgPosTree = [], orgDeptTree = [] } = data || {}
    const orgDeptList = orgDeptTree.map((item: any) => item.data)
    orgPosTree.forEach((item: any) => { item.level = 0 })
    const deep = async (item: any, index: number, arr: any[]) => {
      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((lows: any) => { lows.level = 1 })
        return {
          name: item.data.name,
          level: item.level,
          id: item.id,
          children: await Promise.all(item.children.map(deep)),
        }
      } else {
        if (item.level > 5) return
        let result
        let result1
        let resultgroup
        if (item.level === 3) {
          // result = await api.getNetworkDevList({ orgId: UserModule.orgInfo.orgId, netId: item.netId })
          // console.log('data' + JSON.stringify(result))
          // console.log(item);
          
          result = await api.getPosNetworkGroupList({netId:item.netId })
          // result1 = await api.getNetworkDevListByElectric({ orgId: UserModule.orgInfo.orgId, netId: item.netId })
        // console.log(resultgroup);
        
          result.forEach((item: any) => { item.level = 4 })
          // console.log(item);
          
          return {
            name: item.aliasName,
            id: item.netId,
            level: 3,

            children: await Promise.all(result.map(deep)),
          }
        } else if (item.level === 4) {
          result = await api.getNetworkDevList({ orgId: UserModule.orgInfo.orgId, netId: item.netId })

          // console.log(4);
          // console.log(result);
          
          // console.log(item);
          
          // result = await api.getPosNetworkGroupList({netId: item.id })
          // console.log('网络列表' + JSON.stringify(result));
          // console.log(result);
          
          
          result.devList.forEach((item: any) => { item.level = 5 })
          // console.log(item);
          
          return {
            name: item.name,
            id: item.groupId,
            level:4,
            groupId:item.groupId,
            children: await Promise.all(result.devList.map(deep)),
          }
          
          // return {
          //   name: item.devName,
          //   id: item.devId,
          //   level: 4,
          // }
        } else if (item.level === 5) {
          // console.log(5);
          
          return {
            name: item.devName,
            id: item.devId,
            level:5,
          }
        } 
        
        else {
          result = await api.getPosNetworkList({ orgId: UserModule.orgInfo.orgId, posId: item.id })
          // console.log('网络列表' + JSON.stringify(result));
          // console.log(result);
          
          
          result.netList.forEach((item: any) => { item.level = 3 })
          // console.log(item);
          
          return {
            name: item.data.name,
            id: item.id,
            level: 2,

            children: await Promise.all(result.netList.map(deep)),
          }
        }
      }
    }
    const orgPosTreeResult = await Promise.all(orgPosTree.map(deep))
    // console.log(orgPosTree.map(deep))
    
    // const orgPosTreeResult = []

    console.log('区域位置', orgPosTreeResult)
    console.log('部门列表', orgDeptList)
    this.setOrgPosList(orgPosTreeResult)
    this.setOrgDeptList(orgDeptList)
    return orgPosTreeResult
  }
  @Action
  public async getOrgPosTreeByElectric() {
    const data = await api.getOrgPosTree({ orgId: UserModule.orgInfo.orgId })
    const { orgPosTree = [], orgDeptTree = [] } = data || {}
    orgPosTree.forEach((item: any) => { item.level = 0 })
    const deep1 = async (item: any, index: number, arr: any[]) => {
      if (Array.isArray(item.children) && item.children.length > 0) {
        item.children.forEach((lows: any) => { lows.level = 1 })
        return {
          name: item.data.name,
          level: item.level,
          id: item.id,
          children: await Promise.all(item.children.map(deep1)),
        }
      } else {
        if (item.level > 4) return
        let result
        let result1
        if (item.level === 3) {
          // result = await api.getNetworkDevList({ orgId: UserModule.orgInfo.orgId, netId: item.netId })
          result = await api.getNetworkDevListByElectric({ orgId: UserModule.orgInfo.orgId, netId: item.netId })
          // console.log('data' + JSON.stringify(result))
          result.devList.forEach((item: any) => { item.level = 4 })
          return {
            name: item.aliasName,
            id: item.netId,
            level: 3,
            children: await Promise.all(result.devList.map(deep1)),
          }
        } else if (item.level === 4) {
          return {
            name: item.devName,
            id: item.devId,
            level: 4,
          }
        } else {
          result = await api.getPosNetworkList({ orgId: UserModule.orgInfo.orgId, posId: item.id })
          result.netList.forEach((item: any) => { item.level = 3 })
          return {
            name: item.data.name,
            id: item.id,
            level: 2,
            children: await Promise.all(result.netList.map(deep1)),
          }
        }
      }
    }
    const orgPosTreeResult1 = await Promise.all(orgPosTree.map(deep1))
    this.setOrgPosListByElectric(orgPosTreeResult1)
    return orgPosTreeResult1
  }
  @Mutation
  private setOrgPosList(data: any) {
    this.orgPosList = data
  }
  @Mutation
  private setOrgDeptList(data: any) {
    this.orgDeptList = data
  }
  @Mutation
  private setOrgPosListByElectric(data: any) {
    this.orgPosListByElectric = data
  }
}

export const UserModule = getModule(User)
